import { PayloadAction } from '@reduxjs/toolkit';
import {
  TApplicationReport,
  TApplicationReportActionMeta,
} from '~/components/ApplicationReports/types.ts';
import {
  TCompletedForms,
  TIdentificationStore,
  TTaxResidencyPrefillResponse,
} from '~/store/identification-form/types.ts';
import { setErrorAction, TStoreErrorAction } from '~/store/identification-form/actions/actions.ts';
import { EMPTY_ERROR } from '~/constants/errorCodes';

export const applicationReportActionPending = (
  state: TIdentificationStore,
  action: TApplicationReportActionMeta
) => {
  state.error = EMPTY_ERROR;
  state.applicationReportActionPendingId = String(action.meta.arg.applicationId);
};

export const applicationReportFulfilled = (
  state: TIdentificationStore,
  action: PayloadAction<TApplicationReport>
) => {
  state.loading = false;
  state.error = EMPTY_ERROR;
  state.applicationReportForm = action.payload;
};

export const getApplicationReportExcelFulfilled = (state: TIdentificationStore) => {
  state.loading = false;
  state.error = EMPTY_ERROR;
};

export const taxResidencyPrefillFulfilled = (
  state: TIdentificationStore,
  action: PayloadAction<TTaxResidencyPrefillResponse>
) => {
  state.loading = false;
  state.error = EMPTY_ERROR;

  (state.formData.completedForms as TCompletedForms).isTaxResidencyAdditionalInformationCompleted =
    action.payload.isCompleted;
  state.formData.taxResidencyAdditionalInformation =
    action.payload.taxResidencyAdditionalInformationDTO;
};

export const applicationReportActionFulfilled = (state: TIdentificationStore) => {
  state.error = EMPTY_ERROR;
  state.applicationReportActionPendingId = null;
};

export const applicationReportActionRejected = (
  state: TIdentificationStore,
  action: TStoreErrorAction
) => {
  setErrorAction(state, action);
  state.applicationReportActionPendingId = null;
};
